/**
 * TripRiskSignals Component - Displays risk signals for a trip
 */

import React from "react";
import { Alert, Space, Typography, Tag } from "antd";
import {
  WarningOutlined,
  ExclamationCircleOutlined,
  InfoCircleOutlined,
} from "@ant-design/icons";
import styled from "styled-components";

const { Text } = Typography;

const RisksContainer = styled.div`
  margin-top: 16px;
`;

const RiskItem = styled(Alert)`
  margin-bottom: 8px;
  border-radius: 4px;
`;

const getSeverityType = (severity) => {
  const types = {
    high: "error",
    medium: "warning",
    low: "info",
  };
  return types[severity] || "info";
};

const getSeverityIcon = (severity) => {
  const icons = {
    high: <ExclamationCircleOutlined />,
    medium: <WarningOutlined />,
    low: <InfoCircleOutlined />,
  };
  return icons[severity] || <InfoCircleOutlined />;
};

const TripRiskSignals = ({ risks = [] }) => {
  if (!risks || risks.length === 0) {
    return null;
  }

  // Sort by severity (high first)
  const sortedRisks = [...risks].sort((a, b) => {
    const severityOrder = { high: 3, medium: 2, low: 1 };
    return (
      (severityOrder[b.severity] || 0) - (severityOrder[a.severity] || 0)
    );
  });

  return (
    <RisksContainer>
      <Space direction="vertical" style={{ width: "100%" }} size="small">
        {sortedRisks.map((risk, index) => (
          <RiskItem
            key={index}
            type={getSeverityType(risk.severity)}
            icon={getSeverityIcon(risk.severity)}
            message={
              <Space>
                <Tag color={risk.severity === "high" ? "red" : "orange"}>
                  {risk.severity.toUpperCase()}
                </Tag>
                <Text strong>{risk.message}</Text>
              </Space>
            }
            description={
              risk.orders && risk.orders.length > 0 ? (
                <Text type="secondary" style={{ fontSize: "12px" }}>
                  Affected orders: {risk.orders.join(", ")}
                </Text>
              ) : null
            }
            showIcon
          />
        ))}
      </Space>
    </RisksContainer>
  );
};

export default TripRiskSignals;

